export const extractStackShortId = (stackName: string) =>
  stackName.replace('ZazumeBackendStack', '')
